import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from "./../../../shared/shared.service";
import { AdminDevoteeService } from './../../services/admin-devotee.service';

import { PagingGridData } from "./../../models/paging-grid-data";
import { AdminMobileappService } from '../../services/admin-mobileapp.service';
import { DevoteeDetail } from '../../../Devotee/devotee-detail';

@Component({
  selector: 'app-devotee-list',
  templateUrl: './devotee-list.component.html',
  styleUrls: ['./devotee-list.component.css'],
  providers: [AdminDevoteeService, AdminMobileappService]
})
export class DevoteeListComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private sharedService: SharedService,
    private adminDevoteeService: AdminDevoteeService,
    private adminMobileAppService: AdminMobileappService) { }

  devoteeList: DevoteeDetail[] = [];
  pagingGridData: PagingGridData;
  errorMessage: string = "";
  searchForm: FormGroup;

  ngOnInit() {

    this.createSearchForm();

    // this.sharedService.showSpinner();
    // this.adminDevoteeService.getDevotee().subscribe(
    //   data => this.devoteeList = data,
    //   err => this.errorMessage = err,
    //   () => this.sharedService.hideSpinner()
    // )
    if (localStorage.getItem)
      var oldSearchFormValue = (JSON.parse(localStorage.getItem("DevoteeSearchForm")));

    console.log(oldSearchFormValue);

    if (oldSearchFormValue != null) {
      this.searchForm.setValue(oldSearchFormValue);
      this.devoteeSearch();
    }
  }

  devoteeSearch() {
    this.pageChanged(1);
  }

  resetSearch() {
    this.searchForm.reset();
    this.pageChanged(1);
  }


  pageChanged(pageNo: number) {

    localStorage.setItem("DevoteeSearchForm", JSON.stringify(this.searchForm.value));

    let searchGridEntity = { ...this.searchForm.value };

    searchGridEntity.PageNo = pageNo;

    this.sharedService.showSpinner();
    this.adminDevoteeService.searchDevotee(searchGridEntity).subscribe(
      data => {
        console.log(data);
        this.pagingGridData = data;
        //this.loadMobileAppDevotee(searchGridEntity.MobileNo);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner()
      },
      () => this.sharedService.hideSpinner()
    )

  }



  createOrder(devotee: DevoteeDetail) {

    if (!devotee.MobileNo || devotee.MobileNo == 0) {
      let makeOrder = confirm("Devotee Mobile No is not register, Do you want to create order without mobile no ?");
      if (!makeOrder) {
        return;
      }
    }

    this.router.navigate(['pujaprasadorder', devotee.Id]);
  }

  getMobileNo(devotee: DevoteeDetail) {

    return devotee.MobileNo +
      (devotee.AlternetMobileNo1 != null ? ', ' + devotee.AlternetMobileNo1 : "") +
      (devotee.AlternetMobileNo2 != null ? ', ' + devotee.AlternetMobileNo2 : "");
  }


  createSearchForm(): void {
    this.searchForm = this.formBuilder.group({
      PDN: [],
      FirstName: [""],
      MiddleName: [""],
      LastName: [""],
      AddressLine1: [""],
      AddressLine2: [""],
      AddressLine3: [""],
      AddressLine4: [""],
      City: [""],
      State: [""],
      PinCode: [""],
      MobileNo: [""],
      Email: [""],
    });
  }

}


// "CurrentPage": 1,
// "TotalPages": 313,
// "PageSize": 50,
// "TotalCount": 15641,
// "HasPrevious": false,
// "HasNext": true,


// WEBPACK FOOTER //
// ./src/app/admin/components/devotee-list/devotee-list.component.ts